import React from "react";
import styled from "styled-components";

const PrivacyPage = () => {
  return (
    <PolicyContainer>
      <h1>Privacy Policy</h1>
      <p>
        This privacy policy ("Policy") describes how the personally identifiable
        information ("Personal Information") you may provide on the{" "}
        <strong>slayerscape.com</strong> website ("Website" or "Service") and
        any of its related products and services (collectively, "Services") is
        collected, protected, and used. It also describes the choices available
        to you regarding our use of your Personal Information and how you can
        access and update this information. This Policy is a legally binding
        agreement between you ("User", "you" or "your") and this Website
        operator ("Operator", "we", "us" or "our"). By accessing and using the
        Website and Services, you acknowledge that you have read, understood,
        and agree to be bound by the terms of this Policy. This Policy does not
        apply to the practices of companies that we do not own or control, or to
        individuals that we do not employ or manage.
      </p>

      <h2>Automatic Collection of Information</h2>
      <p>
        When you open the Website, our servers automatically record information
        that your browser sends. This data may include information such as your
        device's IP address, browser type and version, operating system type and
        version, language preferences, or the webpage you were visiting before
        you came to the Website and Services, pages of the Website and Services
        that you visit, the time spent on those pages, information you search
        for on the Website, access times and dates, and other statistics.
      </p>
      <p>
        Information collected automatically is used only to identify potential
        cases of abuse and establish statistical information regarding the usage
        and traffic of the Website and Services. This statistical information is
        not otherwise aggregated in such a way that would identify any
        particular user of the system.
      </p>

      <h2>The Rights of Users</h2>
      <p>
        You may exercise certain rights regarding your information processed by
        us. In particular, you have the right to do the following:
      </p>
      <ul>
        <li>
          (i) You have the right to withdraw consent where you have previously
          given your consent to the processing of your information;
        </li>
        <li>
          (ii) You have the right to object to the processing of your
          information if the processing is carried out on a legal basis other
          than consent;
        </li>
        <li>
          (iii) You have the right to learn if information is being processed by
          us, obtain disclosure regarding certain aspects of the processing and
          obtain a copy of the information undergoing processing;
        </li>
        <li>
          (iv) You have the right to verify the accuracy of your information and
          ask for it to be updated or corrected;
        </li>
        <li>
          (v) You have the right, under certain circumstances, to restrict the
          processing of your information, in which case, we will not process
          your information for any purpose other than storing it;
        </li>
        <li>
          (vi) You have the right, under certain circumstances, to obtain the
          erasure of your Personal Information from us;
        </li>
        <li>
          (vii) You have the right to receive your information in a structured,
          commonly used and machine-readable format and, if technically
          feasible, to have it transmitted to another controller without any
          hindrance. This provision is applicable provided that your information
          is processed by automated means and that the processing is based on
          your consent, on a contract which you are part of, or on
          pre-contractual obligations thereof.
        </li>
      </ul>

      <h2>Data Protection Rights Under GDPR</h2>
      <p>
        If you are a resident of the European Economic Area (EEA), you have
        certain data protection rights and the Operator aims to take reasonable
        steps to allow you to correct, amend, delete, or limit the use of your
        Personal Information. If you wish to be informed what Personal
        Information we hold about you and if you want it to be removed from our
        systems, please contact us. In certain circumstances, you have the
        following data protection rights:
      </p>
      <ul>
        <li>
          You have the right to request access to your Personal Information that
          we store and have the ability to access your Personal Information.
        </li>
        <li>
          You have the right to request that we correct any Personal Information
          you believe is inaccurate. You also have the right to request us to
          complete the Personal Information you believe is incomplete.
        </li>
        <li>
          You have the right to request the erase your Personal Information
          under certain conditions of this Policy.
        </li>
        <li>
          You have the right to object to our processing of your Personal
          Information.
        </li>
        <li>
          You have the right to seek restrictions on the processing of your
          Personal Information. When you restrict the processing of your
          Personal Information, we may store it but will not process it further.
        </li>
        <li>
          You have the right to be provided with a copy of the information we
          have on you in a structured, machine-readable and commonly used
          format.
        </li>
        <li>
          You also have the right to withdraw your consent at any time where the
          Operator relied on your consent to process your Personal Information.
        </li>
        <li>
          You have the right to complain to a Data Protection Authority about
          our collection and use of your Personal Information. For more
          information, please contact your local data protection authority in
          the European Economic Area (EEA).
        </li>
      </ul>

      <h2>California Privacy Rights</h2>
      <p>
        In addition to the rights as explained in this Policy, California
        residents who provide Personal Information (as defined in the statute)
        to obtain products or services for personal, family, or household use
        are entitled to request and obtain from us, once a calendar year,
        information about the Personal Information we shared, if any, with other
        businesses for marketing uses. If applicable, this information would
        include the categories of Personal Information and the names and
        addresses of those businesses with which we shared such personal
        information for the immediately prior calendar year (e.g., requests made
        in the current year will receive information about the prior year). To
        obtain this information please contact us.
      </p>

      <h2>How to Exercise These Rights</h2>
      <p>
        Any requests to exercise your rights can be directed to the Operator
        through the contact details provided in this document. Please note that
        we may ask you to verify your identity before responding to such
        requests. Your request must provide sufficient information that allows
        us to verify that you are the person you are claiming to be or that you
        are the authorized representative of such person. You must include
        sufficient details to allow us to properly understand the request and
        respond to it. We cannot respond to your request or provide you with
        Personal Information unless we first verify your identity or authority
        to make such a request and confirm that the Personal Information relates
        to you.
      </p>

      <h2>Privacy of Children</h2>
      <p>
        We recognize the need to provide further privacy protections with
        respect to Personal Information we may collect from children and take
        many special precautions to protect the privacy of children. We do not
        require any Personal Information from them at any time. We encourage
        children to consult with their parents before submitting any information
        to any online resource. We believe parents should be involved in the
        online activities of their children and suggest that parents do their
        best to provide their children with a safe and friendly online
        environment.
      </p>

      <h2>Do Not Track Signals</h2>
      <p>
        Some browsers incorporate a Do Not Track feature that signals to
        websites you visit that you do not want to have your online activity
        tracked. Tracking is not the same as using or collecting information in
        connection with a website. For these purposes, tracking refers to
        collecting personally identifiable information from consumers who use or
        visit a website or online service as they move across different websites
        over time. The Website and Services do not track its visitors over time
        and across third-party websites. However, some third-party sites may
        keep track of your browsing activities when they serve you content,
        which enables them to tailor what they present to you.
      </p>

      <h2>Links to Other Resources</h2>
      <p>
        The Website and Services contain links to other resources that are not
        owned or controlled by us. Please be aware that we are not responsible
        for the privacy practices of such other resources or third parties. We
        encourage you to be aware when you leave the Website and Services and to
        read the privacy statements of each and every resource that may collect
        Personal Information.
      </p>

      <h2>Information Security</h2>
      <p>
        We secure information you provide on computer servers in a controlled,
        secure environment, protected from unauthorized access, use, or
        disclosure. We maintain reasonable administrative, technical, and
        physical safeguards in an effort to protect against unauthorized access,
        use, modification, and disclosure of Personal Information in its control
        and custody. However, no data transmission over the Internet or wireless
        network can be guaranteed. Therefore, while we strive to protect your
        Personal Information, you acknowledge that (i) there are security and
        privacy limitations of the Internet which are beyond our control; (ii)
        the security, integrity, and privacy of any and all information and data
        exchanged between you and the Website and Services cannot be guaranteed;
        and (iii) any such information and data may be viewed or tampered with
        in transit by a third party, despite best efforts.
      </p>

      <h2>Data Breach</h2>
      <p>
        In the event we become aware that the security of the Website and
        Services has been compromised or users' Personal Information has been
        disclosed to unrelated third parties as a result of external activity,
        including, but not limited to, security attacks or fraud, we reserve the
        right to take reasonably appropriate steps, including but not limited
        to, investigation and reporting, as well as notification to and
        cooperation with law enforcement authorities.
      </p>

      <h2>Changes and Amendments</h2>
      <p>
        We reserve the right to change this Policy or its terms related to the
        Website and Services at any time at our discretion. When we do, we will
        revise the updated date at the bottom of this page. We may also provide
        notice to you in other ways at our discretion, such as through the
        contact information you provide.
      </p>
      <p>
        An updated version of this Policy will be effective as of the date of
        the posting. You are encouraged to review this Policy frequently to stay
        informed of updates.
      </p>

      <h2>Acceptance of This Policy</h2>
      <p>
        You acknowledge that you have read this Policy and agree to all its
        terms and conditions. By accessing and using the Website and Services
        you agree to be bound by this Policy. If you do not agree to abide by
        the terms of this Policy, you are not authorized to access or use the
        Website and Services.
      </p>

      <h2>Contacting Us</h2>
      <p>If you have any questions about this Policy, please contact us:</p>
      <ul>
        <li>Email: cpdewolf@gmail.com</li>
        <li>Website: slayerscape.com</li>
      </ul>

      <p>Last updated: Nov 1, 2024.</p>
    </PolicyContainer>
  );
};

export default PrivacyPage;

const PolicyContainer = styled.div`
  color: rgba(255, 255, 255, 0.85);
  padding: 20px;
  max-width: 800px;
  margin: auto;
  line-height: 1.6;
`;
